import { inject, Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import {
  MenuStructureService,
  NavItemType,
} from '@core/layouts/menu-structure.service';
import { NavItemAccessService } from '@core/layouts/nav-item-access.service';

@Injectable({
  providedIn: 'root',
})
export class RedirectGuard implements CanActivate {
  private readonly router = inject(Router);

  private readonly navItemAccessService = inject(NavItemAccessService);
  private readonly menuStructureService = inject(MenuStructureService);

  /**
   * note: this is a temporary solution and has this logic
   * - find the first nav item that user is allowed to access
   * - redirect to that nav item
   * - if no nav item is found, redirect to access-denied page
   *
   * in future, when we have a proper "home" page logic with previews etc, we should refactor this guard matching the new requirements
   */
  canActivate(): UrlTree {
    const menuItems = this.menuStructureService.sidebarMenu;

    // find first nav item that user is allowed to access
    const firstAllowedNavItem = menuItems
      .flatMap((section) => section.items)
      .find(
        (navItem) =>
          this.navItemAccessService.allowedToAccess(navItem)() &&
          navItem.type === NavItemType.RouterLink,
      );

    if (
      !firstAllowedNavItem ||
      firstAllowedNavItem.type !== NavItemType.RouterLink
    ) {
      return this.router.parseUrl('/access-denied');
    }

    return this.router.parseUrl(firstAllowedNavItem.routerLink);
  }
}
